/**
 * @generated SignedSource<<951467f217b7b80c29447f75caa0a085>>
 * @relayHash abf98366ae34ffd1f8b11a9f6e296e42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe89a0048379d250f0d0d63fea37ec5e51eabf66a8cd926fb797e653f452a422

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraHarmonisedBusinessTimelineQuery } from './src_jiraHarmonisedBusinessTimelineQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraHarmonisedBusinessTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fe89a0048379d250f0d0d63fea37ec5e51eabf66a8cd926fb797e653f452a422",
    "metadata": {},
    "name": "src_jiraHarmonisedBusinessTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
